<template>
    <div class="border-dashed border min-w-screen min-h-screen flex flex-col justify-center items-center">
        <LoadingIcon></LoadingIcon>
        <Loadingbar :message="message" :percent="percent"/>
    </div>
</template>

<script setup>
import LoadingIcon from "../../ui/icons/LoadingIcon.vue";
import Loadingbar from "./Loadingbar.vue";
import {onMounted, ref} from 'vue'
import LoadingService from '@src/services/loading.ts'
import useStore from "@src/stores/store";
import {useAuthStore} from "@src/stores/auth";
import {initEcho} from "@src/services/echo";
import {useInternalChatStore} from "@src/stores/internalChat";

const auth = useAuthStore();
const store = useStore();
const internalChatStore = useInternalChatStore();
const percent = ref(0)
const message = ref('Conectando...')

function increasePercent(newMessage = null) {
    percent.value = Math.min(percent.value + 8, 100)

    if(newMessage !== null && newMessage !== '') {
        message.value = newMessage
    }
}

onMounted(async () => {
    try {
        if(!auth.user) {
            store.goToLogin();
            return;
        }

        initEcho();

        store.setUser(auth.user);
        store.setLastSync("user", new Date().toISOString());

        // Sequencial: getUser pode ser pré-requisito
        await LoadingService.getUser();

        // Paralelo: todos iniciam juntos, barra avança conforme cada um termina
        await Promise.all([
            LoadingService.getPermissions().then(() => increasePercent('Buscando informações do sistema')),
            LoadingService.getVcards().then(() => increasePercent()),
            LoadingService.getLocations().then(() => increasePercent()),
            LoadingService.getTemplatesMessages().then(() => increasePercent()),
            LoadingService.getTags().then(() => increasePercent()),
            LoadingService.getDepartments().then(() => increasePercent()),
            LoadingService.getChannels().then(() => increasePercent()),
            LoadingService.getContacts().then(() => increasePercent('Sincronizando mensagens')),
            LoadingService.getSessions().then(() => increasePercent()),
            LoadingService.getMessages().then(() => increasePercent()),
            LoadingService.getKanbans().then(() => increasePercent()),
            LoadingService.getBotSessions().then(() => increasePercent()),
            LoadingService.getGroups().then(() => increasePercent()),
            internalChatStore.loadUsers().then(() => increasePercent()),
        ]);

        if(store.status !== 'blocked') {
            store.setStatus("success");
        }
        store.delayLoading = false;

    } catch(e) {
        console.error(e);
        store.goToLogin();
    }
})


</script>

<style scoped>

</style>